/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
import React, {Component} from 'react';
import { ClipLoader } from 'react-spinners';
import {  Col, Row} from 'reactstrap';
import loadsStore from '../../../stores/loads-store';

import JmpModal from './customModal';

class CompleteLoad extends Component{

    constructor(props) {
        super(props);
        this.state = {
          isModalOpen: false,
          isCouldNotCompleteModalOpen:false,
          isloading:false
        }
        this.loadEvents=[
            {name:loadsStore.getEventPrefix('loaderActivity'), func:this.handleNewActivity},
        ];
    }

    componentWillMount=()=>{
        //console.log('CreateJump componentWillMount');
        this.loadEvents.forEach((evnt)=>loadsStore.on(evnt.name,evnt.func))
     }

     componentWillUnmount=()=>{
         this.loadEvents.forEach((evnt)=>loadsStore.removeListener(evnt.name,evnt.func));
     }

     handleNewActivity =(activityString)=>{
    	//console.log('in handleNewActivity');
        //console.log(activityString);
        if(activityString)
        {
            this.setState({
                isloading: false,
                isModalOpen: false
            })
        }
    }

    componentDidMount=()=>{
       console.log('CreateLoad componentDidMount');
    }

    toggleModal=() =>{
        this.setState({
          isModalOpen: !this.state.isModalOpen
        });
    }

    toggleModalCouldNotComplete=() =>{
        this.setState({
        	isCouldNotCompleteModalOpen: !this.state.isCouldNotCompleteModalOpen
        });
    }

    loadNotComplete=(load) =>{
    	var notComplete = false;
    	console.log()
    	notComplete = load.tandemJumps.some(jump =>{
    		if(jump.instructor.firstname==="HOLD"  &&jump.instructor.lastname==="" || jump.instructor.firstname==="NONE"  &&jump.instructor.lastname==="") return true;
    		if(jump.videographer!==undefined && jump.videographer.firstname==="HOLD" && jump.videographer.lastname==="")return true;
    		return false;
    	});

    	if(notComplete) return notComplete;

    	notComplete = load.affJumps.some(jump =>{

    		if((jump.mainInstructor.firstname==="HOLD" && jump.mainInstructor.lastname==="" )|| (jump.mainInstructor.firstname==="NONE" && jump.mainInstructor.lastname==="")) return true;
    		if(jump.videographer!==undefined && jump.videographer.firstname==="HOLD"&&jump.videographer.lastname==="")return true;
    		if(jump.secondaryInstructor !== undefined && ((jump.secondaryInstructor.firstname==="HOLD" && jump.secondaryInstructor.lastname==="")|| (jump.secondaryInstructor.firstname==="NONE" && jump.secondaryInstructor.lastname===""))) return true;
    		return false;
    	});

    	if(notComplete) return notComplete;

    	notComplete = load.funJumps.some(jump =>{
    		if(jump.jumpType==="Undecided") return true;
    		return false;
    	});
        if(notComplete) return notComplete;

    	notComplete = load.coachJumps.some(jump =>{
    		if((jump.coach.firstname==="HOLD" && jump.coach.lastname==="") || (jump.coach.firstname==="NONE" && jump.coach.lastname==="")) return true;
    		return false;
    	});

    	return notComplete;


    }

    handleSubmit = (load) => {
        console.log(load, "in handle submit load");
        this.setState({
            isloading:true
        })
        if(this.loadNotComplete(load)){
            this.toggleModalCouldNotComplete();
            this.setState({
                isloading: false,
                isModalOpen: false
            })
        }
        else {
            this.props.onClickBtn()
            console.log(load,"load load load")
            loadsStore.completeLoad(load.loadNum);
        }
        //event.preventDefault();
    }

    render(){
        const override = `
        display: block;
        margin: 0 auto;
        border-color: red;
        `;

        return(
            <div>
                 <JmpModal
                    isModalOpen={this.state.isModalOpen}
                    title={`Complete Load`}
                >
                    <div className='complete-loading'>
                        <ClipLoader
                            css={override}
                            sizeUnit={"px"}
                            size={35}
                            color={'#fff'}
                            loading={this.state.isloading}
                        />
                    </div>
                    {!this.state.isloading ? <span>Confirm Complete Load?</span> : ''}

                    <Row className="form-group m-t-1-rem">
                        <Col md={{size:10}}>
                        <button
                            className="btn btn-bg lightColor createButton"
                            type="submit"
                            onClick={() => this.handleSubmit(this.props.load)}
                        >
                            COMPLETE
                        </button>
                        <button
                            onClick={(e) => {e.preventDefault(); this.toggleModal();this.props.onClickBtn() } }
                        className="btn btn-link">CANCEL</button>
                        </Col>
                    </Row>
                </JmpModal>
                <JmpModal
                    isModalOpen={this.state.isCouldNotCompleteModalOpen}
                    title={`Complete Load`}
                >
                    Could not complete Load, there are HOLDS!!
                    <Row className="form-group m-t-1-rem">
                        <Col md={{size:10}}>
                            <button onClick={(e) => {e.preventDefault(); this.toggleModalCouldNotComplete();this.props.onClickBtn()} } className="btn btn-bg lightColor createButton">CLOSE</button>
                        </Col>
                    </Row>
                </JmpModal>
                {/* <button style={{borderRadius:'100px'}} className="btn lightBlueButton" onClick = {this.toggleModal}>
                    <i className="fa fa-check" /> LOAD{' '}
                </button> */}
                 <ul className="menu-header-option">
                        <li>
                          <span
                            onClick={() =>
                              this.toggleModal()
                            }
                          >
                            Complete Load
                          </span>
                        </li>
                      </ul>
            </div>
        );
    }
 }

 export default CompleteLoad
